import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Contract, { DispatchProps, OwnProps, StateProps } from './ContractTab';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from '../../../../../../../../types/grid';
import { getContracts } from '../../../../../../../../store/actions/contract-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.contracts.data,
        inProgress: state.contracts.inProgress,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) =>
            dispatch(
                getContracts({
                    ...params,
                    filters: {
                        ...params.filters,
                        'student.id': ownProps.student?.id,
                    },
                }),
            ),
    };
}

const ContractTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(mapStateToProps, mapDispatchToProps)(Contract);

export default ContractTab;
